import { useRouter } from 'next/router';
import { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export function AppWrapper({ children }) {

    const router = useRouter()

    // filter item in models page
    const [modelFilters, setModelFilters] = useState(router.query?.filters ? JSON.parse(router?.query?.filters) : {})

    // sort item in models page
    const [modelSort, setModelSort] = useState()

    // favourites item in models page
    const [favourites, setFavourites] = useState([])

    // active filter in models and filter page
    const [activeFilter, setActiveFilter] = useState(0)

    // labels on model filters page
    const [modelLabels, setModelLabels] = useState({})

    // material labels on model filters page
    const [materialLabels, setMaterialLabels] = useState({})

    // save final filters on models
    let [modelsFilter, setModelsFilter] = useState({})

    // filter item in contractors page
    const [contractorsFilter, setSepecialistsFilter] = useState({})

    // sort item in contractors page
    const [contractorsSort, setspecialistsSort] = useState(undefined)

    // models location filter
    const [modelLocation, setModelLocation] = useState({})


    // FORM CONTEXT //
    // page counter step
    const [current, setCurrent] = useState(0);
    // when from req was success show modal message
    const [success, setSuccess] = useState(false)
    // when selected  city not support show a modal message
    const [notSupport, setNotSupport] = useState(false)
    // step on material detail
    const [step, setStep] = useState(0);
    // set workTypes material
    const [material, setMaterial] = useState(null);

    // form page config
    const [formConfigs, setFormConfigs] = useState([])

    const [updateProjectBody, setUpdateProjectBody] = useState({});


    // CONTRACTORS CONTEXT //
    // all wrok samples Status (contractors page)
    const [allWrokSampleStatus, setAllWrokSampleStatus] = useState(false)

    // all model videos Status (contractors page)
    const [allModelVideosStatus, setAllModelVideosStatus] = useState(false)

    // model offsetTop value for scrolling
    const [modelOffsetTop, setModelOffsetTop] = useState(undefined)
    const [refFlag, setRefFlag] = useState(false)

    // tabriz landing page's language switch value
    const [tabrizLanguage, setTabrizLanguage] = useState(false)

    // showing models page new modal component
    const [showNewFilters, setShowNewFilters] = useState(false)
    // tabriz landing page's language switch value
    const [behsaRes, setBehsaRes] = useState()

    // profile bookmark
    const [bookmark, setBookMark] = useState(false)

    // profile bookmark
    const [searchedPages, setSearchedPages] = useState(false)

    let sharedState = {

        // filter item in models page
        modelFilters,
        setModelFilters,

        // sort item in models page
        modelSort,
        setModelSort,

        // favourites item in models page
        favourites,
        setFavourites,

        // active filter in models and filter page
        activeFilter,
        setActiveFilter,

        // labels on model filters page
        modelLabels,
        setModelLabels,

        // material labels on model filters page
        materialLabels,
        setMaterialLabels,

        // save final filters on models
        modelsFilter,
        setModelsFilter,

        // models location filter
        modelLocation,
        setModelLocation,


        // FORM CONTEXT //
        // page counter step
        current,
        setCurrent,

        // when from req was success show modal message
        success,
        setSuccess,

        // when selected  city not support show a modal message
        notSupport,
        setNotSupport,

        // step on material detail
        step,
        setStep,

        // set workTypes material
        material,
        setMaterial,

        // form configs
        formConfigs,
        setFormConfigs,

        updateProjectBody,
        setUpdateProjectBody,

        

        // CONTRACTOR CONTEXT //
        // all wrok samples Status (specialist page)
        allWrokSampleStatus,
        setAllWrokSampleStatus,

        // filter item in contractors page
        contractorsFilter,
        setSepecialistsFilter,

        // sort item in contractorsSort page
        contractorsSort,
        setspecialistsSort,

        // model offsetTop value for scrolling
        modelOffsetTop,
        setModelOffsetTop,
        refFlag,
        setRefFlag,

        // tabriz landing page's language switch value
        tabrizLanguage,
        setTabrizLanguage,

        // showing models page new modal component
        showNewFilters,
        setShowNewFilters,
        // behsa form request response data
        behsaRes,
        setBehsaRes,

        bookmark,
        setBookMark,

        searchedPages,
        setSearchedPages
    }

    return (
        <AppContext.Provider value={sharedState}>
            {children}
        </AppContext.Provider>
    );
}

export function useAppContext() {
    return useContext(AppContext);
}
